import React from "react";

function AddGatePass() {
  return <div>AddGatePass</div>;
}

export default AddGatePass;
